import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import RequestItem from './RequestItem';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading, error, message, newRequestItem,
  } = state.request;
  return {
    isLoading,
    error,
    message,
    newRequestItem,
  };
}

const Styled = withStyles(styles)(RequestItem);

export default connect(
  mapStateToProps,
)(Styled);
